import { useState, useEffect, useRef, RefObject } from "react";

/**
 * 菜單狀態管理服務
 * 提供菜單開關狀態管理和點擊外部關閉功能
 */
export function useMenuService() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);

  const menuRef = useRef<HTMLDivElement>(null);
  const menuButtonRef = useRef<HTMLDivElement>(null);

  /**
   * 切換主選單狀態
   */
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (isUserMenuOpen) setIsUserMenuOpen(false);
  };

  /**
   * 切換用戶菜單狀態
   */
  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  /**
   * 關閉所有菜單
   */
  const closeAllMenus = () => {
    setIsMenuOpen(false);
    setIsUserMenuOpen(false);
  };

  /**
   * 設置點擊外部關閉用戶菜單
   * @param targetRef 目標菜單的 ref
   * @param buttonRef 觸發菜單的按鈕 ref
   * @param isOpen 菜單是否開啟
   * @param setIsOpen 設置菜單開啟狀態的函數
   */
  const useClickOutside = <T extends HTMLElement>(
    targetRef: RefObject<T>,
    buttonRef: RefObject<T>,
    isOpen: boolean,
    setIsOpen: (isOpen: boolean) => void,
  ) => {
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          isOpen &&
          targetRef.current &&
          buttonRef.current &&
          !targetRef.current.contains(event.target as Node) &&
          !buttonRef.current.contains(event.target as Node)
        ) {
          setIsOpen(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, targetRef, buttonRef, setIsOpen]);
  };

  // 設置點擊外部關閉用戶菜單
  useClickOutside(menuRef, menuButtonRef, isUserMenuOpen, setIsUserMenuOpen);

  return {
    isMenuOpen,
    isUserMenuOpen,
    menuRef,
    menuButtonRef,
    toggleMenu,
    toggleUserMenu,
    closeAllMenus,
    useClickOutside,
  };
}
